import React from 'react'
import omit from 'lodash/omit'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Icon } from 'semantic-ui-react'
import { darken } from 'polished'

const TextComponent = styled(
  (
    {
      as: Element,
      children,
      content,
      style,
      icon,
      inline,
      sizes,
      color,
      bold,
      uppercase,
      secondary,
      primary,
      inverted,
      ...otherProps
    }) => {
    return (
      <Element style={style} {...omit(otherProps, ['bold', 'uppercase', 'inline', 'strikethrough'])}>
        {(icon) && (<Icon name={icon} />)}
        {content || children}
      </Element>
    )
  }
)`
  ${({ as, color, theme: { colors = {}, text = {} }, theme }) => (() => {
    let hoverColor
    if (color) {
      hoverColor = darken(0.08, colors[color] || (as === 'a' ? colors.primary : colors.black))
    } else {
      try {
        hoverColor = text[as].hoverColor || text.hoverColor
      } catch (e) {
        hoverColor = text.hoverColor
      }
    }
    return { ':hover': { color: hoverColor } }
  })()}
  ${({ inline }) => (inline ? { display: 'inline' } : {})};
  ${({ as }) => (as === 'a' ? { cursor: 'pointer' } : {})};
  ${({ uppercase }) => uppercase ? 'text-transform: uppercase;' : ''}
  color: ${({ as, color, primary, secondary, theme: { colors = {}, text = {} }, theme }) => (() => {
    let textColor
    if (color) {
      textColor = colors[color] || (as === 'a' ? colors.primary : colors.black)
    } else if (primary) {
      textColor = colors.primary || colors.black
    } else if (secondary) {
      textColor = colors.secondary || colors.black
    } else {
      try {
        textColor = text[as].color || text.color
      } catch (e) {
        textColor = text.color
      }
    }

  return textColor
})()};
  font-size: ${({ as, size, theme: { text } }) => (text[as].size[size])};
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
`

TextComponent.propTypes = {
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'p', 'span', 'a']),
  className: PropTypes.string,
  color: PropTypes.string,
  content: PropTypes.node,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive']),
  bold: PropTypes.bool,
  inverted: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  inline: PropTypes.bool,
  uppercase: PropTypes.bool,
}

TextComponent.defaultProps = {
  as: 'span',
  className: '',
  color: undefined,
  content: undefined,
  children: [],
  size: 'medium',
  bold: false,
  uppercase: false,
  inline: false,
}

export default TextComponent



// WEBPACK FOOTER //
// ./src/cms/CmsText.js